import { useTranslation } from 'next-i18next'

import { HomepageHeadingH1 } from '@/components/homepage/styled'
import { HOMEPAGE_GPT_ID } from '@/components-page/homepage/advertisement/homepageAdSlots'
import { useTakeoverDetection } from '@/hooks/useTakeoverDetection'

export const HomepageH1 = () => {
  const { t } = useTranslation('home')
  const hasTakeover = useTakeoverDetection(HOMEPAGE_GPT_ID.TAKEOVER)

  return <HomepageHeadingH1 $hasTakeover={hasTakeover}>{t('heading.h1')}</HomepageHeadingH1>
}
